<div class="main-container d-flex align-items-center justify-content-center">
  <div class="content-wrapper">
    <!-- Logo centrado arriba -->
    <div class="img-documents-container text-center mb-4">
      <img src="../../../../assets/images/logo-dark.png" alt="Logo">
    </div>

    <!-- Contenedor principal de la orden -->
    <div class="download-documents-container col-8 mx-auto" *ngIf="!isLoading && !errorMessage">
      <div class="order-card">
        <!-- El resto de tu contenido permanece igual -->
        <div class="back">
          <div class="div-title">
            <h2 class="client-name">{{ orderData?.client?.name }} {{ orderData?.client?.lastname }}</h2>

            <div *ngIf="showImportantDates" class="div-clocks text-secondary">
              <span class="clocks" *ngFor="let clock of clocks">
                <i class="icon-clock"></i>
                {{ "badge-status_select-stage."+ clock.key | translate }} {{clock.value}}
              </span>
            </div>
            <span *ngIf="orderData?.campaign_id" class="badge text-badge" [ngClass]="'campaign' | badgeClient">
              <i class="icon-bullhorn text-sm icon-white"></i>
              {{orderData?.campaign_name }}
            </span>
            <span class="badge text-badge" [ngClass]="stage | badgeColor:orderData.require_action:orderData.priority">
              {{ "badge-status_select-stage." + stage | translate }}
            </span>
            <span *ngIf="orderData.client?.name" class="badge text-badge"
              [ngClass]="orderData.client?.type | badgeClient">
              {{ "inputs." + orderData.client?.type | translate }}
            </span>
            <span *ngIf="orderData?.guarantee?.name" class="badge text-badge"
              [ngClass]="'guarantee' | badgeClient">
              {{ "inputs.with_guarantee" | translate }}
            </span>
          </div>
        </div>

        <hr />

        <!-- Datos del vehículo -->
        <div class="vehicle-container-info">

          <div class="vehicle-info col-6">
            <div class="model">{{ orderData?.vehicle }}</div>
            <span *ngIf="orderData?.vehicle_status" class="badge text-badge-list"
              [ngClass]="orderData.vehicle_status | badgeVehicle">{{
              "badge-status_select-stage."
              + orderData?.vehicle_status | translate }} </span>
            <div class="details">
              <span class="badge"
                [ngClass]="{'new': orderData?.vehicle_status === 'new', 'used': orderData?.vehicle_status === 'used'}">
                {{ orderData?.vehicle_status === 'new' ? 'Nuevo' : 'Usado' }}
              </span>
              <!-- <span class="separator">|</span> -->
              <div class="vehicle-items">
                <span class="icon-brush2"></span><span>{{ orderData?.colour }}</span>
              </div>
              <!-- <span class="separator">|</span> -->
              <div class="vehicle-items">
                <span>{{ orderData?.duration }} meses</span>
              </div>
              <!-- <span class="separator">|</span> -->
              <div class="vehicle-items">
                <span>{{ orderData?.total_kms }} kms</span>
              </div>
              <!-- <span class="separator">|</span> -->
              <div class="vehicle-items">
                <span class="icon-coin-euro"></span> <span>{{ orderData?.monthly_fee_total }} €/mes</span>
              </div>
            </div>
          </div>

          <div class="references col-6">
            <div class="ref-block">
              <div class="ref-label">{{ orderData?.broker?.name }}</div>
              <div class="ref-value" *ngIf="orderData?.broker_reference"><i class="icon-barcode"></i> {{
                orderData?.broker_reference }}</div>
            </div>
            <div class="ref-block">
              <div class="ref-label">{{ orderData?.supplier?.name }}</div>
              <div class="ref-value" *ngIf="orderData?.supplier_reference"><i class="icon-barcode"></i>{{
                orderData?.supplier_reference || 'Sin referencia' }}
              </div>
            </div>
            <div class="ref-block">
              <div class="ref-label">{{ orderData?.vendor?.name }}</div>
              <div class="ref-value" *ngIf="orderData?.vendor_quote_reference">
                <i class="icon-barcode"></i>
                {{ orderData?.vendor_quote_reference }}
              </div>
              <div class="ref-value" *ngIf="orderData?.vendor_reference">
                <i class="icon-barcode"></i>{{ orderData?.vendor_reference }}
              </div>
            </div>
          </div>
        </div>

        <hr />
        <div class="action-section">

          <form [formGroup]="updateStageForm">
            <input type="text" type="hidden" formControlName="notes_visibility" id="notes_visibility" name="notes_visibility" />
            <div class="row">
              <div class="col-6">
                <div class="mb-3">
                  <label for="stage" class="form-label">{{ "inputs.stage" | translate }}</label>
                  <div class="input-group">
                  <select id="stage" class="form-control" formControlName="stage" (ngModelChange)="changeStage($event)">
                    <option value="" disabled selected>{{ "inputs.select_option" | translate }}</option>
                    <option [value]="orderData.stage">
                      {{
                      "badge-status_select-stage." + orderData.stage
                      | translate
                      }}
                    </option>
                    <option *ngFor="let type of orderData.stages" [value]="type" [selected]="type === orderData.stage">
                      {{
                      "badge-status_select-stage." + type | translate
                      }}
                    </option>
                  </select>
                  </div>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="mb-3 addnote">
                <label for="notes" class="form-label ">{{
                  "inputs.addnote" | translate
                  }}</label>
                <textarea class="form-control textarea150" id="notes" rows="5" formControlName="notes"></textarea>
              </div>
            </div>
          </form>

          <div class="documents-section">
            <div class="documents-list">
              <div class="document-item">
                <button class="btn btn-primary btn-primary-form ng-star-inserted" (click)="updateOrder()"
                    [disabled]="isUpdating || !hasFormChanges">
                  {{"buttons.update_order" | translate}}
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div *ngIf="isLoading" class="loading text-center">Cargando...</div>
    <div *ngIf="errorMessage" class="error text-center">{{ errorMessage }}</div>
  </div>
</div>
